export default "__VITE_ASSET__B21C3WIx__"